import React, { useContext } from 'react'
import { Select, MenuItem } from '@material-ui/core'

import { useStyles } from 'styles/styles'
import AppContext from 'components/app/AppContext'

interface LocaleSelectorProps {
    onSelectLocale: (locale: string) => void
}

const LocaleSelector: React.FC<LocaleSelectorProps> = (props) => {
    const classes = useStyles()
    const appContext = useContext(AppContext)
   
    const handleSelectLocale = (event: React.ChangeEvent<{ name?: string; value: unknown }>) => {
        props.onSelectLocale(event.target.value as string)
    }

    return (
        <Select
            id="language-select-outlined"
            className={classes.languageSelect}
            value={appContext.locale}
            onChange={handleSelectLocale}
            variant="outlined"
        >
            {appContext.locales.map(locale =>
                <MenuItem key={locale.code} value={locale.code}>{locale.name}</MenuItem>
            )}
        </Select>
    )
}

export default LocaleSelector
